/**
 * Colour palettes, shared with the Meierij ERP. Values live in `styles/globals.css` under
 * `[data-palette]`; `swatch` is [page, accent] in light mode, for pickers.
 */
export const PALETTES = [
  { id: "meierij", swatch: ["#ffffff", "#b91f4b"] },
  { id: "zacht", swatch: ["#f3f1eb", "#b91f4b"] },
  { id: "leisteen", swatch: ["#f4f6f8", "#4a6784"] },
  { id: "salie", swatch: ["#f3f5f2", "#55735f"] },
  { id: "zand", swatch: ["#f5f2ee", "#9a6a4f"] },
  { id: "mist", swatch: ["#f5f5f7", "#6e6a8e"] },
] as const

export type Palette = (typeof PALETTES)[number]["id"]

/** Also read by the pre-paint script in `index.html`; keep the two in sync. */
export const PALETTE_STORAGE_KEY = "mit.palette"
export const DEFAULT_PALETTE: Palette = "meierij"

export const isPalette = (value: unknown): value is Palette => PALETTES.some((p) => p.id === value)
